import { render, staticRenderFns } from "./VideoPlayAcademy.vue?vue&type=template&id=5e02b1d6&scoped=true&"
import script from "./VideoPlayAcademy.vue?vue&type=script&lang=js&"
export * from "./VideoPlayAcademy.vue?vue&type=script&lang=js&"
import style0 from "./VideoPlayAcademy.vue?vue&type=style&index=0&id=5e02b1d6&scoped=true&lang=css&"
import style1 from "./VideoPlayAcademy.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e02b1d6",
  null
  
)

export default component.exports